// extracted by mini-css-extract-plugin
export var map = "contacts-modules--map--1WHx2";
export var address = "contacts-modules--address--2gbZw";
export var aside = "contacts-modules--aside--7MYUn";